"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const visa_master_png_1 = __importDefault(require("../../../../static/payments/visa_master.png"));
const applepay_svg_1 = __importDefault(require("../../../../static/payments/applepay.svg"));
const diners_svg_1 = __importDefault(require("../../../../static/payments/diners.svg"));
const googlepay_svg_1 = __importDefault(require("../../../../static/payments/googlepay.svg"));
const pix_png_1 = __importDefault(require("../../../../static/payments/pix.png"));
// https://alchemypay.readme.io/docs/fiat-currency-country-payment-method-coverage-plus-fees-and-limits
const paymentOptions = [
    { icon: visa_master_png_1.default, id: "visa_master" },
    { icon: diners_svg_1.default, id: "diners" },
    { icon: applepay_svg_1.default, id: "apple_pay" },
    { icon: googlepay_svg_1.default, id: "google_pay" },
    { icon: pix_png_1.default, id: "pix" },
];
exports.default = paymentOptions;
//# sourceMappingURL=paymentOptions.js.map